module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sponsors"
  }, [_c('div', {
    staticClass: "container is-fluid"
  }, [_c('div', {
    staticClass: "columns is-centered"
  }, [_c('div', {
    staticClass: "column is-8 content"
  }, [_c('h1', {
    staticClass: "title has-text-white"
  }, [_vm._v("\n          Call for Sponsors & Partners\n        ")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/img/eventspace/mlmu_december.jpg",
      "alt": "machine learning meetup bratislava in coworking"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "subtitle has-text-white"
  }, [_c('br'), _vm._v("\n          Progressbar Cowork & hackerspace is looking for sponsors & partners to help us with the space.\n          We can offer to give our sponsors marketing push."), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n          We are in need to cover the costs of coworking equipment."), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n          The space capacity is about 80 people for meetups. Meetup organizators, contact us."), _c('br'), _vm._v("\n          Technical meetups are preferred."), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n          We held 150+ meetups previous year with 5000+ attendees"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n          We can offer you to place your banner/rollup in our space."), _c('br'), _vm._v("\n          We can put your company logo on our page."), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n          We have also "), _c('router-link', {
    attrs: {
      "to": "/crowdfunding"
    }
  }, [_vm._v("campaign running")]), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n          We have sponsor tiers"), _c('br'), _vm._v(" "), _vm._m(0)], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', [_c('ul', [_vm._v("\n              45k€/year - Block producer"), _c('br'), _vm._v("\n              10k€/month - Governance vote"), _c('br'), _vm._v("\n              1k€/month - Buy me maté"), _c('br')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a88fce0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CallForTheSponsors.vue
// module id = 257
// module chunks = 4